import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionActions from '@material-ui/core/AccordionActions';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

const RequestAccordion = ({ label, Icon, Chips, Action, Details }) => {
    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    className="bg-light-grey"
                >
                    {Icon}
                    <Typography style={{ marginLeft: `4px`, marginRight: `8px` }}>{` ${label} `}</Typography>
                    {Chips}
                </AccordionSummary>
                <Divider />
                <AccordionActions>
                    {Action}
                </AccordionActions>
                <Divider />
                <AccordionDetails style={{ flexDirection: `column` }}>
                    {Details}
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default RequestAccordion;